import { Card, type CardProps, cn } from '@sr/ui-library';

/** App-level section card: ui-library {@link Card} with MSR3 list-page padding/layout. */
export type AppCardProps = Pick<CardProps, 'children' | 'className'>;

export const AppCard = ({ className, ...props }: AppCardProps) => (
  <Card
    className={cn('flex w-full flex-col p-4 sm:p-6', className)}
    {...props}
  />
);
